<div class="create_popup">
    <div class="modal-body">
      <div class="card p-3 my-2">
        <!-- File Name -->
        <div class="col-md-12">
          <b>File Name</b>
          <input type="text" class="form-control" [(ngModel)]="fileName" />
        </div>
  
        <!-- Export As -->
        <div class="col-md-12 mt-2">
          <b>Export As</b>
          <ng-select
            [(ngModel)]="exportFormat"
            [items]="['Excel', 'CSV', 'PDF']"
            bindLabel="label"
            placeholder="Select format"
          ></ng-select>
        </div>
  
        <!-- Select Columns -->
        <div class="col-md-12 mt-2 multi-select-height" *ngIf="!includeLineItems">
          <b>Select Columns</b>
          <ng-select
            [multiple]="true"
            [items]="dropdownOptions"
            bindLabel="label"
            bindValue="value"
            appendTo="body"
            [(ngModel)]="columnsToExport"
          >
            <ng-template ng-header-tmp *ngIf="!includeLineItems">
              <div class="d-flex justify-content-end">
                <button class="btn ng-select-btn btn-primary ms-1"
                        (click)="selectAllColumns()">Select All</button>
                <button class="btn ng-select-btn btn reset-btn btn-cancel ms-1"
                        (click)="clearAllColumns()">Clear All</button>
              </div>
            </ng-template>
          </ng-select>
        </div>
        
      </div>
  
      <!-- Buttons -->
      <div class="row">
        <div class="col d-flex justify-content-center">
          <button type="button" class="btn btn-primary mr-3" (click)="onExport()" [disabled]="!exportFormat">Export</button>
          <button *ngIf="!includeLineItems" type="button" class="btn reset-btn btn-cancel mx-2" (click)="onPrint()">Print</button>
        </div>
      </div>
  
      <!-- Hidden export components (trigger via ViewChild) -->
      <div style="display: none;">
        <!-- EXCEL -->
          <app-download-excel
            #excelExporter
            [data]="selectedRows"
            [fileName]="fileName"
            [columnsToExport]="columnsToExport"
            [allColumns]="allColumns"
            [customHeaders]="customHeaders">
        </app-download-excel>

        <!-- CSV -->
        <app-common-csv 
        #csvExporter
        [data]="selectedRows" 
        [columnsToExport]="columnsToExport" 
        [allColumns]="allColumns" 
        [fileName]="fileName"
        [customHeaders]="customHeaders"></app-common-csv>

        <!-- PDF -->
        <app-common-bulk-print
        #pdfExporter 
        [data]="selectedRows" 
        [columns]="allColumns" 
        [columnsToExport]="columnsToExport" 
        [downloadPdf]="true"
        [print]="false" 
        [fileName]="fileName"
        [customHeaders]="customHeaders"></app-common-bulk-print>

        <!-- <app-common-bulk-print #pdfExporter [columns]="[]" [data]="[]" [fileName]="fileName" [columnsToExport]="columnsToExport"></app-common-bulk-print> -->

      </div>
    </div>
  </div>
  